import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps {
  establishmentChoiceEntryId: string;
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject = ({
  establishmentChoiceEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentRejectProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${establishmentChoiceEntryId}/establishment_reject`);
    },
    ...options
  });
}
